import { render, staticRenderFns } from "./ViewContentNotification.vue?vue&type=template&id=b7dbd42c&scoped=true"
import script from "./ViewContentNotification.vue?vue&type=script&lang=js"
export * from "./ViewContentNotification.vue?vue&type=script&lang=js"
import style0 from "./ViewContentNotification.vue?vue&type=style&index=0&id=b7dbd42c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dbd42c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7dbd42c')) {
      api.createRecord('b7dbd42c', component.options)
    } else {
      api.reload('b7dbd42c', component.options)
    }
    module.hot.accept("./ViewContentNotification.vue?vue&type=template&id=b7dbd42c&scoped=true", function () {
      api.rerender('b7dbd42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/notification/ViewContentNotification.vue"
export default component.exports